import  { useState } from 'react';




function Form(props) {
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [company, setCompany] = useState('');
  const [program, setProgram] = useState(props.program || '');
  const [policy, setPolicy] = useState(false);
  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!firstname.trim()) {
      newErrors.firstname = 'First name is required';
    }

    if (!lastname.trim()) {
      newErrors.lastname = 'Last name is required';
    }

    if (!phone.trim()) {
      newErrors.phone = 'Phone number is required';
    } else if (!/^\d+$/.test(phone)) {
      newErrors.phone = 'Phone number must be numeric';
    } else if (phone.length < 9) {
      newErrors.phone = 'Phone number must be at least 9 digits';
    }

    if (!company.trim()) {
      newErrors.company = 'Company name is required';
    }

    if (!email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!policy) {
      newErrors.policy = 'You must agree to the policy';  
    }

    setErrors(newErrors);
  
    if (Object.keys(newErrors).length === 0) {
      console.log('Form data submitted:', {
        firstname,
        lastname,
        email,
        phone,
        company,
        program
      });
      setLoading(true);
      try {
        let response;
        // response = await fetch('https://server4-rzyi.onrender.com/register', { 
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        //   body: JSON.stringify({
        //     firstname,
        //     lastname,
        //     email,
        //     phone,
        //     company,
        //     program
        //   }),
        // });
        if (program === 'operational_risk') {
          response = await fetch('https://server4-rzyi.onrender.com/register', { 
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              firstname,
              lastname,
              email,
              phone,
              company,
              program
            }),
          });
        }else if (program === 'risk_management_for_microfinance') {
          response = await fetch('https://server4-rzyi.onrender.com/register2', { 
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              firstname,
              lastname,
              email,
              phone,
              company,
              program
            }),
          });
        }
        // const response = await fetch('https://server4-rzyi.onrender.com/register', { 
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        //   body: JSON.stringify({
        //     firstname,
        //     lastname,
        //     email,
        //     phone,
        //     company,
        //     program
        //   }),
        // });
        
        if (response.ok) {
          const result = await response.json();
          console.log('Registration successful:', result);
          if (props.onlanguage === 'eng') {
            alert("Registration successful! Thank you for registering for our training. You will receive additional information via email.");
          } else  if (props.onlanguage === 'geo') {
            alert("რეგისტრაცია წარმატებით დასრულდა! გმადლობთ, რომ დარეგისტრირდით ჩვენს ტრენინგზე. დამატებით ინფორმაციას მიიღებთ ელფოსტაზე.");
        }
          setFirstname('');
          setLastname('');
          setEmail('');
          setPhone('');
          setCompany('');
          setProgram(props.program || '');
          setPolicy(false);
        } else if (response.status === 500) {
          const errorData = await response.json();
          console.error('Registration failed:', errorData);
          setErrors((prevErrors) => ({
            ...prevErrors,
            api: errorData.message || 'User already registered.',
          }));
          alert("User already registered. Please try again with a different email.");
          
       // } else if (response.status === 500) { 
         // console.error('Server error:', response.statusText);
          //setErrors((prevErrors) => ({
          //  ...prevErrors,
          //  api: 'Server error. Please try again later.',
         // }));
         // alert("Server error. Please try again later.");
        }else {
          const errorData = await response.json();
          console.error('Registration failed:', errorData);
          alert("Something went wrong on the server. Please try again later.");
          setErrors((prevErrors) => ({
            ...prevErrors,
            api: errorData.message || 'Something went wrong on the server.',
          }));
        }
      } catch (error) {
        console.error('Error submitting form:', error);
        alert("Network error. Please try again.");
        setErrors((prevErrors) => ({
          ...prevErrors,
          api: 'Network error. Please try again.',
        }));
      }finally{
        setLoading(false);
      }
    }
  };

  return (
        <div>
          <div>
            <div>
              <form style={{ borderRadius: '8px', borderColor: '#003968', borderStyle: 'solid', borderWidth: '1px', padding: '20px' }}>
                <div className="mb-3">
                    <label htmlFor="firstname" className="form-label"><div className={props.onEngLanguage()}>First Name</div><div className={props.onGeoLanguage()}>სახელი</div></label>
                    <input
                        type="text"
                        className="form-control"
                        name="firstname"
                        id="firstname"
                        aria-describedby="helpId"
                        placeholder=""
                        value={firstname}
                        onChange={(e)=> setFirstname(e.target.value) } 
                    />
                    {errors.firstname && <p style={{ color: 'red' }}>{errors.firstname}</p>}
                </div>
                <div className="mb-3">
                    <label htmlFor="lastname" className="form-label"><div className={props.onEngLanguage()}>Last Name</div><div className={props.onGeoLanguage()}>გვარი</div></label>
                    <input
                        type="text"
                        className="form-control"
                        name="lastname"
                        id="lastname"
                        aria-describedby="helpId"
                        placeholder=""
                        value={lastname}
                        onChange={(e)=> setLastname(e.target.value)}
                    />
                    {errors.lastname && <p style={{ color: 'red' }}>{errors.lastname}</p>}
                </div>
                <div className="mb-3">
                    <label htmlFor="email" className="form-label"><div className={props.onEngLanguage()}>Email</div><div className={props.onGeoLanguage()}>ელ ფოსტა</div></label>
                    <input
                        type="email"
                        className="form-control"
                        name="email"
                        id="email"
                        aria-describedby="emailHelpId"
                        placeholder="abc@mail.com"
                        value={email}
                        onChange={(e)=> setEmail(e.target.value)}
                    />
                    {errors.email && <p style={{ color: 'red' }}>{errors.email}</p>}
                </div>
                <div className="mb-3">
                    <label htmlFor="phone" className="form-label"><div className={props.onEngLanguage()}>Phone number</div><div className={props.onGeoLanguage()}>საკონტაქტო ტელეფონი</div></label>
                    <input
                        type="text"
                        className="form-control"
                        name="phone"
                        id="phone"
                        aria-describedby="helpId"
                        placeholder=""
                        value={phone}
                        onChange={(e)=> setPhone(e.target.value)}
                    />
                    {errors.phone && <p style={{ color: 'red' }}>{errors.phone}</p>}
                </div>
                <div className="mb-3">
                    <label htmlFor="company" className="form-label"><div className={props.onEngLanguage()}>Company</div><div className={props.onGeoLanguage()}>კომპანია</div></label>
                    <input
                        type="text"
                        className="form-control"
                        name="company"
                        id="company"
                        aria-describedby="helpId"
                        placeholder=""
                        value={company}
                        onChange={(e)=> setCompany(e.target.value)}
                    />
                    {errors.company && <p style={{ color: 'red' }}>{errors.company}</p>}
                </div>
                <div className="mb-3">
                    <label htmlFor="policy" className="form-label" style={{textAlign: 'justify', textJustify: 'inter-word', fontSize: '0.7rem'}}>
                      <div className={props.onEngLanguage()}>
                        I hereby consent to RiskAdvisor collecting and
                        processing my personal data (name, surname, email, phone number) per the Personal Data Protection Law. 
                        This includes permission to use training recordings for marketing.  
                      </div>
                      <div className={props.onGeoLanguage()}>
                        თანახმა ვარ, რომ „RiskAdvisor”-მა შეინახოს და დაამუშავოს ჩემი
                        პირადი მონაცემები (სახელი, გვარი, ელ ფოსტა, საკონტაქტო
                        ტელეფონი) „პერსონალურ მონაცემთა დაცვის შესახებ“
                        კანონთან შესაბამისობაში. მათ შორის, გამოიყენოს ტრენინგის
                        დროს გადაღებული მასალა, მარკეტინგული მიზნებისათვის.
                      </div>
                    </label>
                    <br />
                    <div className='checkbox-group'>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        name="policy"
                        id="policy"
                        checked={policy}
                        onChange={(e)=> setPolicy(e.target.checked)}
                      />
                      <label htmlFor="policy" className="form-label"><div className={props.onEngLanguage()}>I agree</div><div className={props.onGeoLanguage()}> გავეცანი და ვეთანხმები</div></label>
                    </div>

                    {errors.policy && <p style={{ color: 'red' }}>{errors.policy}</p>}
                </div>

                <button type="submit" disabled={loading} className="mt-3 btn btn-primary" onClick={handleSubmit}>
                  {loading && <div>
                    <span className="spinner-border spinner-border-sm ms-1 me-2" role="status" aria-hidden="true"></span>
                    Loading...
                  </div>}
                  {!loading &&  <div><div className={props.onEngLanguage()}>Register</div> <div className={props.onGeoLanguage()}>რეგისტრაცია</div></div>}
                </button>
              </form>
            </div>
          </div>     
        </div>
  );
}
export default Form;





